<template>
    <div class="page order-detail">
        <!-- 头部 -->
        <head-bar title="订单详情" :fixed="true">
            <template v-slot:right>
                <div class="head-right-slot">
                    <router-link to="/product/search">
                        <i class="head-search-icon"></i>
                    </router-link>
                    <router-link to="/">
                        <i class="head-home-icon"></i>
                    </router-link>
                </div>
            </template>
        </head-bar>
        <!-- 内容 -->
        <transition name="van-fade">
            <div class="content" v-show="!pageLoading">
                <!-- 订单状态 -->
                <div class="order-status">
                    <h4>{{ orderDetail.clientOrderStatusDes }}</h4>
                    <p
                        v-if="
                            orderDetail.clientOrderStatus ==
                                orderStatusMap.waitPay
                        "
                    >
                        <em>{{ orderCancelTime }}</em>
                        <span>后将自动取消订单，请尽快付款</span>
                    </p>
                </div>
                <!-- 物流信息 -->
                <div v-if="logisticsTrajectory.expressNumber">
                    <logistics-step
                        v-for="(logisticsInfo,
                        index) in logisticsTrajectory.logisticsInformationBoList"
                        :key="index"
                        :logisticsInfo="logisticsInfo"
                    ></logistics-step>
                </div>
                <!-- 物流信息 -->
                <div
                    class="transfer-info"
                    v-if="
                        orderDetail.payType == payTypesMap.offlinePay &&
                            orderDetail.newOrderType == true
                    "
                >
                    <h4>转账信息</h4>
                    <p>公司名称：&nbsp;深圳市油柑科技有限公司</p>
                    <p>开户银行：&nbsp;中国工商银行股份有限公司深圳华强支行</p>
                    <p>
                        银行账号：&nbsp;4000&nbsp;0221&nbsp;0920&nbsp;0744&nbsp;484
                    </p>
                </div>
                <!-- 转账信息: 对公支付才显示 -->
                <div
                    v-if="
                        orderDetail.payType == payTypesMap.offlinePay &&
                            orderDetail.newOrderType == false
                    "
                    class="transfer-info"
                >
                    <h4>转账信息</h4>
                    <p>公司名称：&nbsp;深圳市油柑科技有限公司</p>
                    <p>开户银行：&nbsp;中国工商银行股份有限公司深圳华强支行</p>
                    <p>
                        银行账号：&nbsp;4000&nbsp;0221&nbsp;0920&nbsp;0744&nbsp;484
                    </p>
                    <!-- 有水单数据 -->
                    <template v-if="transferInfo.transferNo">
                        <!-- 上传水单 -->
                        <div
                            v-if="
                                transferInfo.payState ==
                                    remittanceStatusMap.waitAudit
                            "
                            class="transfer-form"
                        >
                            <div
                                class="transfer-form-item clearfix is-required"
                            >
                                <label>公司名称</label>
                                <input
                                    type="text"
                                    v-model="transferInfo.companyName"
                                    placeholder="请输入公司名称"
                                />
                            </div>
                            <div class="transfer-form-item clearfix">
                                <label>流水单号</label>
                                <input
                                    type="text"
                                    v-model="transferInfo.payNo"
                                    placeholder="选填"
                                />
                            </div>
                            <div
                                class="transfer-form-item clearfix is-required"
                            >
                                <label>水单照片</label>
                                <ul class="img-list">
                                    <li
                                        v-for="(item,
                                        index) in transferInfo.payBillImgList"
                                        :key="index"
                                    >
                                        <div class="img-box">
                                            <img
                                                :src="$config.QINIU_URL + item"
                                            />
                                            <i @click="delPicture(index)"></i>
                                        </div>
                                    </li>
                                    <li
                                        v-show="
                                            transferInfo.payBillImgList.length <
                                                3
                                        "
                                    >
                                        <div class="img-add">
                                            <p>
                                                上传凭证
                                                <br />（最多3张）
                                            </p>
                                            <input
                                                type="file"
                                                @change="pictureChange"
                                            />
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="transfer-btn">
                                <van-button
                                    type="default"
                                    @click="uploadPayVoucher"
                                    size="small"
                                    plain
                                    round
                                    >修改</van-button
                                >
                            </div>
                        </div>
                        <!-- 展示水单 -->
                        <div
                            v-if="
                                transferInfo.payState ==
                                    remittanceStatusMap.auditSuccess ||
                                    transferInfo.payState ==
                                        remittanceStatusMap.auditFailure
                            "
                            class="transfer-form"
                        >
                            <div class="transfer-form-item clearfix">
                                <label>公司名称</label>
                                <span>{{
                                    transferInfo.companyName || "未上传公司名称"
                                }}</span>
                                <div style="clear: both"></div>
                                <label>流水单号</label>
                                <span>{{
                                    transferInfo.payNo || "未上流水单号"
                                }}</span>
                            </div>
                            <div
                                class="transfer-form-item clearfix"
                                v-if="transferInfo.payBillImgList.length"
                            >
                                <label>水单照片</label>
                                <ul class="img-list">
                                    <li
                                        v-for="(item,
                                        index) in transferInfo.payBillImgList"
                                        :key="index"
                                    >
                                        <div class="img-box">
                                            <img
                                                :src="$config.QINIU_URL + item"
                                            />
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </template>
                    <!-- 无水单数据 -->
                    <template v-else>
                        <!-- 上传水单 -->
                        <div
                            v-if="
                                orderDetail.clientOrderStatus !=
                                    orderStatusMap.closeStatus
                            "
                            class="transfer-form"
                        >
                            <div
                                class="transfer-form-item clearfix is-required"
                            >
                                <label>公司名称</label>
                                <input
                                    type="text"
                                    v-model="transferInfo.companyName"
                                    placeholder="请输入公司名称"
                                />
                            </div>
                            <div class="transfer-form-item clearfix">
                                <label>流水单号</label>
                                <input
                                    type="text"
                                    v-model="transferInfo.payNo"
                                    placeholder="选填"
                                />
                            </div>
                            <div
                                class="transfer-form-item clearfix is-required"
                            >
                                <label>水单照片</label>
                                <ul class="img-list">
                                    <li
                                        v-for="(item,
                                        index) in transferInfo.payBillImgList"
                                        :key="index"
                                    >
                                        <div class="img-box">
                                            <img
                                                :src="$config.QINIU_URL + item"
                                            />
                                            <i @click="delPicture(index)"></i>
                                        </div>
                                    </li>
                                    <li
                                        v-show="
                                            transferInfo.payBillImgList.length <
                                                3
                                        "
                                    >
                                        <div class="img-add">
                                            <p>
                                                上传凭证
                                                <br />（最多3张）
                                            </p>
                                            <input
                                                type="file"
                                                @change="pictureChange"
                                            />
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="transfer-btn">
                                <van-button
                                    type="default"
                                    @click="uploadPayVoucher"
                                    size="small"
                                    plain
                                    round
                                    >提交</van-button
                                >
                            </div>
                        </div>
                    </template>
                </div>
                <!-- 收货地址 -->
                <div v-if="userReceivingAddress" class="order-address">
                    <h4>
                        {{ userReceivingAddress.province }}
                        {{ userReceivingAddress.city }}
                        {{ userReceivingAddress.district }}
                        {{ userReceivingAddress.detailAddress }}
                    </h4>
                    <p>
                        {{ userReceivingAddress.receiver }}
                        {{ userReceivingAddress.receiverPhone }}
                    </p>
                </div>
                <div class="order-field">
                    <van-field
                        label="订单类型"
                        :value="orderDetail.orderSourceDesc"
                        readonly
                    />
                    <van-field
                        label="送货方式"
                        :value="orderDetail.distributionTypeDes"
                        readonly
                    />
                    <van-field
                        label="下单联系人"
                        :value="orderDetail.linkmanName"
                        readonly
                    />
                    <van-field
                        v-if="orderDetail.orderRemark"
                        label="订单备注"
                        :value="orderDetail.orderRemark"
                        readonly
                    />
                    <van-field
                        label="付款方式"
                        :value="payAndDeliveryTypeInfo.payTypeDes"
                        readonly
                    />
                    <van-field
                        v-if="orderDetail.expressName"
                        label="物流快递"
                        :value="orderDetail.expressName"
                        readonly
                    />
                    <van-field
                        v-if="orderDetail.estimatedDeliveryTime"
                        :label="orderDetail.distributionTypeTimeDes"
                        :value="orderDetail.estimatedDeliveryTime"
                        readonly
                    />
                    <van-field
                        v-if="orderDetail.expressNo"
                        label="快递单号"
                        :value="orderDetail.expressNo"
                        readonly
                    />
                    <van-field
                        v-if="orderDetail.orderPriorityStateDes"
                        label="加急状态"
                        :value="orderDetail.orderPriorityStateDes"
                        readonly
                    />
                    <van-field
                        v-if="
                            payAndDeliveryTypeInfo.urgentEstimatedDeliveryTime
                        "
                        label="加急时间"
                        :value="
                            payAndDeliveryTypeInfo.urgentEstimatedDeliveryTime
                        "
                        readonly
                    />
                </div>
                <!-- 发票信息 -->
                <div class="order-field" v-if="hasFinanceInvoice">
                    <van-field
                        label="开票公司"
                        :value="`${viewInvoice.companyName}`"
                        readonly
                    />
                    <van-field
                        label="税号"
                        :value="`${viewInvoice.taxNo}`"
                        readonly
                    />
                    <van-field
                        label="开户银行"
                        :value="`${viewInvoice.depositBank}`"
                        readonly
                    />
                    <van-field
                        label="银行账户"
                        :value="`${viewInvoice.bankAccount}`"
                        readonly
                    />
                    <van-field
                        label="审核状态"
                        :value="`${viewInvoice.invoiceStatusDesc}`"
                        readonly
                    />
                </div>
                <!-- 发票信息 -->
                <!-- 商品列表 -->
                <div class="order-field">
                    <van-field
                        label="商品金额"
                        :value="`¥${orderDetail.productAmount}`"
                        readonly
                    />
                    <van-field
                        label="商品运费"
                        :value="`¥${orderDetail.expressAmount}`"
                        readonly
                    />
                    <van-field
                        label="运费优惠"
                        :value="`-¥${orderDetail.expressDiscountAmount}`"
                        readonly
                    />
                    <van-field
                        label="优惠金额"
                        :value="`-¥${orderDetail.discountAmount}`"
                        readonly
                    />
                    <van-field
                        v-if="orderDetail.alterPriceDiscountAmount"
                        label="改价减免"
                        :value="`-¥${orderDetail.alterPriceDiscountAmount}`"
                        readonly
                    />
                    <van-field
                        label="订单总额"
                        :value="`¥${orderDetail.tradeAmount}`"
                        readonly
                    />
                </div>
                <!-- 商品列表 -->
                <div class="order-goods">
                    <ul>
                        <li v-for="(item, index) in goodsList" :key="index">
                            <h4>{{ item.goodsName }}</h4>
                            <p>{{ item.factoryCode }}</p>
                            <p v-if="item.customGoodsCode">
                                {{ item.customGoodsCode }}
                            </p>
                            <p>
                                {{ item.brandName }}
                                <span class="batch" v-if="item.batchNo"
                                    >批次&nbsp;&nbsp;{{ item.batchNo }}</span
                                >
                            </p>
                            <h5>
                                <span
                                >
                                    ￥<span :class="{'line-through':item.alterUnitPrice}">{{ item.unitPrice }}</span>
                                    <i>×</i>
                                    {{ item.productQuantity }}pcs
                                </span>
                                <em :class="{'line-through':item.alterUnitPrice}"
                                    >¥ {{ item.totalPrice }}</em
                                >
                            </h5>
                            <h5 v-if="item.alterUnitPrice">
                                <span>
                                    ￥{{ item.alterUnitPrice }}
                                    <i>×</i>
                                    {{ item.productQuantity }}pcs
                                </span>
                                <em>¥ {{ item.alterProductAmount }}</em>
                            </h5>
                            <span
                                v-if="item.returnRefundDetailList"
                                class="returned_button"
                                @click="openReturnedDialog(item)"
                                >退货退款详情</span
                            >
                        </li>
                    </ul>
                    <div
                        v-if="
                            orderDetail.orderDetailList &&
                                orderDetail.orderDetailList.length > 3
                        "
                        @click="spreadGoods = !spreadGoods"
                        class="spread"
                    >
                        <span>{{ spreadGoods ? "收起" : "展开" }}</span>
                        <i :class="{ 'arrow-top-icon': spreadGoods }"></i>
                    </div>
                </div>
                <div class="order-field">
                    <van-field
                        label="订单号"
                        :value="orderDetail.orderNo"
                        readonly
                    />
                    <van-field
                        v-if="orderDetail.customNumber"
                        label="自定义订单编码"
                        :value="orderDetail.customNumber"
                        readonly
                    />
                    <van-field
                        label="下单时间"
                        :value="orderDetail.orderTime"
                        readonly
                    />
                </div>
            </div>
        </transition>
        <!-- 底部操作栏 -->
        <transition name="van-fade">
            <div class="order-btn-box" v-show="!pageLoading">
                <van-button
                    type="default"
                    v-if="
                        orderDetail.clientOrderStatus == orderStatusMap.waitTake
                    "
                    @click="confirmReceipt"
                    size="small"
                    plain
                    round
                    >确认收货</van-button
                >
                <!-- <van-button type="default"
                    v-if="orderDetail.isRefund"
                    @click="returnOrder(1)"
                    size="small"
                    plain
                    round>
          我要退款
        </van-button>
        <van-button type="default"
                    v-if="orderDetail.isReturn"
                    @click="returnOrder(2)"
                    size="small"
                    plain
                    round>
          我要退货
        </van-button>-->
                <van-button
                    type="default"
                    @click="buyAgain"
                    size="small"
                    plain
                    round
                    v-if="orderDetail.orderSource != 3"
                    >再次购买</van-button
                >
                <van-button
                    type="default"
                    v-if="
                        orderDetail.clientOrderStatus == orderStatusMap.waitPay
                    "
                    @click="cancelOrder"
                    size="small"
                    plain
                    round
                    >取消订单</van-button
                >
                <van-button
                    type="primary"
                    v-if="
                        orderDetail.clientOrderStatus ==
                            orderStatusMap.waitPay &&
                            orderDetail.payType != payTypesMap.offlinePay
                    "
                    @click="toPay"
                    size="small"
                    plain
                    round
                    >立即付款</van-button
                >
                <van-button
                    v-if="
                        orderDetail.clientOrderStatus ==
                            orderStatusMap.waitPay &&
                            orderDetail.payType == payTypesMap.offlinePay
                    "
                    plain
                    hairline
                    type="info"
                    color="#4BC227"
                    size="small"
                    plain
                    round
                    @click="popupShow = true"
                    >我已转账</van-button
                >
            </div>
        </transition>
        <ReturnedDialog ref="returnedDialog"></ReturnedDialog>
        <!-- 弹出层 -->
        <van-popup
            closeable
            close-icon-position="top-right"
            close-icon="close"
            v-model="popupShow"
        >
            <div class="view_invoice_container">
                <div class="caption">
                    <span>确认转账信息</span>
                </div>
                <div class="view_list">
                    <div class="caption">开票信息</div>
                    <div class="empty_invoice" v-if="!hasFinanceInvoice">
                        <span>暂无开票信息</span>
                    </div>
                    <div class="view_item" v-if="hasFinanceInvoice">
                        <div class="view_label">
                            <span>公司名称</span>
                        </div>
                        <div class="view_text">
                            <span>{{ viewInvoice.companyName }}</span>
                        </div>
                    </div>
                    <div class="view_item" v-if="hasFinanceInvoice">
                        <div class="view_label">
                            <span>开票税号</span>
                        </div>
                        <div class="view_text">
                            <span>{{ viewInvoice.taxNo }}</span>
                        </div>
                    </div>
                    <div class="view_item" v-if="hasFinanceInvoice">
                        <div class="view_label">
                            <span>开户银行</span>
                        </div>
                        <div class="view_text">
                            <span>{{ viewInvoice.depositBank }}</span>
                        </div>
                    </div>
                    <div class="view_item" v-if="hasFinanceInvoice">
                        <div class="view_label">
                            <span>银行账户</span>
                        </div>
                        <div class="view_text">
                            <span>{{ viewInvoice.bankAccount }}</span>
                        </div>
                    </div>
                    <div class="view_item" v-if="hasFinanceInvoice">
                        <div class="view_label">
                            <span>审核状态</span>
                        </div>
                        <div class="view_text">
                            <span>{{ viewInvoice.invoiceStatusDesc }}</span>
                        </div>
                    </div>
                </div>
                <!-- <div class="prompt_text">
                    <p>
                        请确认实际付款信息与以上信息是否一致。如不一致，请
                        更改开票资料。
                    </p>
                </div> -->
                <div class="view_list">
                    <div class="caption_max">
                        <div class="caption_left">
                            <span>收款信息</span>
                        </div>
                        <div class="caption_right">
                            <span>请使用网银或柜台汇款</span>
                        </div>
                    </div>
                    <div class="view_item">
                        <div class="view_label">
                            <span>收款户名</span>
                        </div>
                        <div class="view_text">
                            <span>深圳市油柑科技有限公司</span>
                        </div>
                    </div>
                    <div class="view_item">
                        <div class="view_label">
                            <span>开户银行</span>
                        </div>
                        <div class="view_text">
                            <span>中国工商银行股份有限公司深圳华强支行</span>
                        </div>
                    </div>
                    <div class="view_item">
                        <div class="view_label">
                            <span>银行卡号</span>
                        </div>
                        <div class="view_text">
                            <span
                                >4000&nbsp;0221&nbsp;0920&nbsp;0744&nbsp;484</span
                            >
                        </div>
                    </div>
                </div>
                <div class="button_group">
                    <div
                        class="button_item later_button"
                        @click="popupShow = false"
                    >
                        <span>稍后转账</span>
                    </div>
                    <div
                        class="button_item confirm_button"
                        @click="confirmRemittance"
                    >
                        <span>我已转账</span>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import Vue from "vue";
import { Field, Button, Dialog, Toast, Popup } from "vant";
import HeadBar from "../../../components/HeadBar";
import LogisticsStep from "../order/children/LogisticsStep";
import ReturnedDialog from "../order/children/ReturnedDialog";
import { uploadFile } from "../../../utils/qiniu";
import utils from "../../../utils/utils";
import { isEmpty } from "@/utils/validation";
import {
    orderStatusMap,
    remittanceStatusMap,
} from "../../../definition/status/order";
import { payTypesMap } from "../../../definition/type/pay";
Vue.use(Field);
Vue.use(Button);
Vue.use(Toast);
Vue.use(Popup);

export default {
    name: "OrderDetail",
    components: {
        HeadBar,
        LogisticsStep,
        ReturnedDialog,
    },
    data() {
        return {
            //汇款状态
            remittanceStatusMap,
            //支付方式
            payTypesMap,
            //订单状态
            orderStatusMap,
            pageLoading: false, // 页面loading
            /* 路由参数 */
            query: {
                orderNo: this.$route.query.orderNo,
            },
            orderDetail: {}, // 订单明细信息
            orderPayOnline: {}, // 在线支付信息
            userReceivingAddress: {}, // 收货地址信息
            financeInvoice: {}, // 发票信息
            payAndDeliveryTypeInfo: {}, //支付信息
            orderCancelTime: "00:00:00", // 倒计时
            // spreadExpress: false, // 是否展开物流
            spreadGoods: false, // 是否展开商品
            timer: null, // 倒计时定时器
            /* 转账信息 */
            transferInfo: {
                orderNo: this.$route.query.orderNo,
                companyName: "", // 公司名称
                payNo: "", // 转账流水号
                payBillImgList: [], // 上传凭证文件名集合
            },
            //物流信息
            logisticsTrajectory: {},
            /* 展示发票数据 */
            viewInvoice: {
                companyName: "", // 公司名称
                taxNo: "", // 公司税号
                registeredAddress: "", // 注册地址
                companyTel: "", // 公司电话
                depositBank: "", // 开户银行
                bankAccount: "", // 银行账号
                invoiceTypeAlias: "", // 开票方式
                receiver: "", // 收票人
                receiverPhone: "", // 手机号码
                /* 省市区编码和名称 */
                provinceCode: "",
                provinceName: "",
                cityCode: "",
                cityName: "",
                countyCode: "",
                countyName: "",
                detailAddress: "", // 详细地址
            },
            popupShow: false, //
        };
    },
    computed: {
        goodsList() {
            let list = [];
            const { orderDetailList } = this.orderDetail;
            if (!orderDetailList || orderDetailList.length == 0) {
                return list;
            }
            if (this.spreadGoods) {
                list = orderDetailList;
            } else {
                list = [...orderDetailList].slice(0, 3);
            }
            return list;
        },
        hasFinanceInvoice() {
            return !isEmpty(this.viewInvoice.companyName);
        },
    },
    created() {
        this.getPageInfo();
    },
    methods: {
        /* 获取页面信息 */
        getPageInfo(cb) {
            this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            const url = this.$api.userApi.order_queryOrderDetail;

            const params = {
                orderNo: this.query.orderNo,
            };

            this.pageLoading = true;
            this.$axios.post(url, params).then((res) => {
                let { data = {} } = res;
                let {
                    orderDetail,
                    orderPayOnline,
                    userReceivingAddress,
                    financeInvoice = {},
                    orderPayTransfer = {},
                    logisticsTrajectory = {},
                    payAndDeliveryTypeInfo = {},
                } = data;
                this.orderDetail = orderDetail;
                this.orderPayOnline = orderPayOnline || {};
                this.userReceivingAddress = userReceivingAddress;
                this.financeInvoice = financeInvoice;
                this.logisticsTrajectory = logisticsTrajectory;
                this.payAndDeliveryTypeInfo = payAndDeliveryTypeInfo;

                if (!isEmpty(financeInvoice)) {
                    this.viewInvoice = Object.assign(
                        { ...this.viewInvoice },
                        { ...financeInvoice }
                    );
                }

                /* 转账信息赋值 */
                if (!isEmpty(orderPayTransfer)) {
                    const {
                        companyName = "",
                        transferNo = "",
                        offLinePayBillImgList = [],
                        payState,
                        paySerialNo = "",
                    } = orderPayTransfer;
                    this.transferInfo.companyName = companyName;
                    this.transferInfo.transferNo = transferNo;
                    this.transferInfo.payBillImgList = offLinePayBillImgList;
                    this.transferInfo.payState = payState;
                    this.transferInfo.payNo = paySerialNo;
                }
                // 倒计时
                const { orderCancelTime } = this.orderDetail;
                if (orderCancelTime > 0) {
                    utils.countDownConversion(
                        orderCancelTime,
                        (times, isEnd) => {
                            this.orderCancelTime = times;
                            if (isEnd) {
                                this.getPageInfo();
                            }
                        }
                    );
                }
                cb && cb();
                this.$toast.clear();
                this.pageLoading = false;
            });
        },
        /* 获取七牛云token */
        getQiniuToken() {
            return new Promise((resolve, reject) => {
                const url = this.$api.commonApi.getQiniuToken;
                this.$axios.post(url).then((res) => {
                    const token = res.data.uploadFileToken || "";
                    resolve(token);
                });
            });
        },
        /* 上传图片 */
        async pictureChange(event) {
            let _this = this;
            const token = await this.getQiniuToken();
            const file = event.target.files[0];
            uploadFile({
                folder: "flowcert",
                token,
                file,
                success: (res) => {
                    let { key } = res;
                    this.transferInfo.payBillImgList.push(key);
                },
                failed: (res) => {
                    let { msg = "请上传小于4M的图片" } = res;
                    _this.$toast.fail({
                        message: msg,
                        duration: 2000,
                    });
                },
            });
        },
        /* 删除图片 */
        delPicture(index) {
            this.transferInfo.payBillImgList.splice(index, 1);
        },
        /* 提交水单 */
        uploadPayVoucher() {
            const {
                orderNo,
                companyName,
                payNo,
                payBillImgList,
            } = this.transferInfo;
            // 校验表单
            if (!companyName) {
                this.$toast("请输入公司名称");
                return;
            }
            if (payBillImgList.length == 0) {
                this.$toast("请上传水单照片");
                return;
            }
            const url = this.$api.userApi.uploadPayVoucher;
            const params = {
                orderNo,
                companyName,
                payNo,
                payBillImgList,
            };

            this.$axios.post(url, params).then((res) => {
                this.$toast.success("提交成功");
                this.getPageInfo();
            });
        },
        /* 确认收货 */
        confirmReceipt() {
            const { orderNo } = this.orderDetail;
            const url = this.$api.userApi.updateOrder;
            const params = {
                orderNo,
                type: 1,
            };
            this.$axios.post(url, params).then((res) => {
                this.getPageInfo();
            });
        },
        /**
         * @description 我要退款 / 退货
         * @param {Number} returnType // 退款1 、退货2
         */
        returnOrder(returnType) {
            const { orderNo } = this.orderDetail;
            let path = "";
            switch (returnType) {
                case 1: // 退款
                    path = "/user/apply/refund";
                    break;
                case 2: // 退货
                    path = "/user/apply/returns";
                    break;
            }
            this.$router.push({
                path,
                query: {
                    orderNo,
                },
            });
        },
        /* 再次购买 */
        buyAgain() {
            const { orderNo, orderId } = this.orderDetail;
            const url = this.$api.userApi.buyAgainProduct;
            const params = {
                orderNo,
                orderId,
            };

            this.$axios.post(url, params).then((res) => {
                this.$router.push("/cart");
            });
        },
        /* 取消订单 */
        cancelOrder() {
            Dialog.confirm({
                title: "提示",
                message: "是否确认取消?",
                confirmBUttonColor: "#4BC227",
            })
                .then(() => {
                    const { orderNo } = this.orderDetail;
                    const url = this.$api.userApi.updateOrder;
                    const params = {
                        orderNo,
                        type: 2,
                    };

                    this.$axios.post(url, params).then((res) => {
                        this.getPageInfo();
                    });
                })
                .catch(() => {});
        },
        /* 立即支付 */
        toPay() {
            const { orderNo, orderId, tradeAmount } = this.orderDetail;
            let { invoiceId = "" } = this.financeInvoice;
            this.$router.push({
                path: "/pay/select",
                query: {
                    orderNo,
                    orderId,
                    invoiceId,
                    orderPrice: tradeAmount,
                },
            });
        },
        /**
         * @description 确认汇款
         */
        confirmRemittance() {
            let { orderNo } = this.orderDetail;
            const params = {
                orderNo,
            };
            const url = this.$api.userApi.uploadPayVoucher;
            this.$axios.post(url, params).then((res) => {
                this.getPageInfo(() => {
                    this.popupShow = false;
                });
            });
        },
        /***
         * @description 打开退货退款弹窗
         */
        openReturnedDialog(productInfo) {
            let { returnedDialog } = this.$refs;
            returnedDialog.open(productInfo);
        },
    },
    destroyed() {
        clearInterval(this.timer);
    },
};
</script>

<style lang="less" scoped>
.order-detail {
    .head-right-slot {
        height: 100%;
        text-align: right;
        padding-right: 20px;

        i {
            display: inline-block;
            width: 60px;
            height: 100%;
            background-repeat: no-repeat;
            background-size: 48px;
            background-position: center;
            margin: 0 10px;

            &.head-search-icon {
                background-image: url(../../../public/images/head/head-search-icon.png);
            }

            &.head-home-icon {
                background-image: url(../../../public/images/head/head-home-icon.png);
            }
        }
    }

    .content {
        bottom: 100px;
        padding-bottom: 200px;

        .order-status {
            color: #fff;
            background: #9da5b1;
            padding: 24px;
            text-align: center;

            h4 {
                font-weight: normal;
                font-size: 34px;
            }

            p {
                font-size: 24px;
                margin-top: 10px;

                em {
                    margin-right: 10px;
                }
            }
        }

        .spread {
            font-size: 24px;
            color: #999;
            height: 60px;
            line-height: 60px;
            text-align: center;
            margin: 0 30px;
            border-top: 1px dashed #888;

            span {
                vertical-align: middle;
            }

            i {
                display: inline-block;
                width: 40px;
                height: 40px;
                background: url(../../../public/images/common/arrow-bottom-icon.png)
                    center no-repeat;
                background-size: 100%;
                vertical-align: middle;

                &.arrow-top-icon {
                    background-image: url(../../../public/images/common/arrow-top-icon.png);
                }
            }
        }

        .order-express {
            background: #fff;

            ul {
                padding: 0 30px;

                li {
                    font-size: 24px;
                    padding-left: 78px;
                    padding: 30px 0 30px 78px;
                    border-bottom: 1px solid #f2f2f2;

                    h4 {
                        line-height: 38px;
                        text-align: justify;
                        font-weight: normal;
                        word-break: break-all;
                    }

                    p {
                        color: #999;
                        margin-top: 10px;
                    }

                    &:first-child {
                        background: url(../../../public/images/user/order/wl-icon.png)
                            left no-repeat;
                        background-size: 48px;
                    }
                }
            }
        }

        .transfer-info {
            background: #fff;
            margin-bottom: 20px;
            padding: 30px 0 40px 40px;

            h4 {
                font-weight: normal;
                font-size: 28px;
                padding-bottom: 20px;
            }

            p {
                font-size: 24px;
                margin-top: 10px;
            }

            .transfer-form {
                margin-top: 28px;

                .transfer-form-item {
                    padding: 25px 0;
                    border-top: 1px solid #f2f2f2;

                    label {
                        float: left;
                        font-size: 28px;
                        width: 140px;
                        height: 60px;
                        line-height: 60px;
                        position: relative;
                    }

                    input,
                    span {
                        float: left;
                        font-size: 24px;
                        border: 0;
                        width: 80%;
                        height: 60px;
                        line-height: 60px;
                    }

                    ul.img-list {
                        margin-top: 70px;
                        overflow: hidden;

                        li {
                            float: left;
                            width: 160px;
                            height: 160px;
                            margin-right: 30px;

                            .img-add {
                                height: 100%;
                                border: 1px dashed #999;
                                box-sizing: border-box;
                                background: url(../../../public/images/order/camera-icon.png)
                                    center 22px no-repeat;
                                background-size: 56px;
                                position: relative;

                                p {
                                    font-size: 20px;
                                    color: #999;
                                    text-align: center;
                                    margin-top: 80px;
                                }

                                input {
                                    opacity: 0;
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    width: 100%;
                                    height: 100%;
                                }
                            }

                            .img-box {
                                height: 100%;
                                position: relative;

                                img {
                                    width: 100%;
                                    height: 100%;
                                }

                                i {
                                    position: absolute;
                                    top: 0;
                                    right: 0;
                                    width: 40px;
                                    height: 40px;
                                    background: url(../../../public/images/order/close-icon.png)
                                        center no-repeat;
                                    background-size: 40px;
                                }
                            }
                        }
                    }

                    &.is-required {
                        label:before {
                            content: "*";
                            color: #ff5500;
                            position: absolute;
                            left: -12px;
                        }
                    }
                }

                .transfer-btn {
                    padding: 0 40px;
                    text-align: right;
                }
            }
        }

        .order-address {
            font-size: 24px;
            padding: 30px 30px 30px 108px;
            margin-bottom: 20px;
            background: #fff url(../../../public/images/user/order/dz-icon.png)
                30px no-repeat;
            background-size: 48px;

            h4 {
                font-weight: normal;
                line-height: 38px;
                text-align: justify;
            }

            p {
                color: #999;
                margin-top: 10px;
            }
        }

        .order-field {
            margin-bottom: 20px;

            .van-cell {
                font-size: 24px;

                /deep/ .van-field__label {
                    color: #999;
                    width: 170px;
                }
            }
        }

        .order-goods {
            background: #fff;
            margin-bottom: 20px;

            .batch {
                padding-left: 20px;
            }

            ul {
                padding: 0 30px;

                li {
                    font-size: 24px;
                    padding: 30px 0;
                    border-top: 1px dashed #888;

                    &:first-child {
                        border-top: none;
                    }

                    h4 {
                        word-break: break-all;
                        font-weight: normal;
                        line-height: 32px;
                    }

                    p {
                        color: #999;
                        margin-top: 6px;
                    }

                    h5 {
                        font-size: 24px;
                        font-weight: normal;
                        margin-top: 6px;

                        span {
                            color: #666;

                            i {
                                margin: 0 20px;
                            }
                        }

                        em {
                            float: right;
                            font-size: 28px;
                        }
                    }

                    .returned_button {
                        *display: inline;
                        display: inline-block;
                        margin: 30px 0 0 460px;
                        border-radius: 38px;
                        border: 1px solid #dedede;
                        width: 220px;
                        height: 56px;
                        font-size: 24px;
                        text-align: center;
                        line-height: 60px;
                    }
                }
            }
        }
    }

    .order-btn-box {
        position: absolute;
        left: 0;
        bottom: 0;
        background: #fff;
        width: 100%;
        height: 100px;
        line-height: 100px;
        text-align: right;
        padding: 0 40px;
        box-sizing: border-box;

        .van-button {
            padding: 0 30px;
            font-size: 13px;
            + .van-button {
                margin-left: 20px;
            }
        }
    }
}

.view_invoice_container {
    overflow: hidden;
    width: 710px;
    > .caption {
        height: 110px;
        font-size: 32px;
        line-height: 110px;
        text-align: center;
    }
    .view_list {
        .empty_invoice {
            margin: 0 auto;
            width: 630px;
            font-size: 24px;
            color: #999;
            height: 100px;
        }
        width: 710px;
        > .caption {
            margin: 0 auto 15px;
            width: 630px;
            font-size: 28px;
            color: #333;
        }
        .caption_max {
            margin: 0 auto;
            width: 630px;
            height: 120px;
            overflow: hidden;
            > .caption_left {
                float: left;
                width: 50%;
                height: 120px;
                line-height: 120px;
                font-size: 28px;
                color: #333333;
            }
            > .caption_right {
                float: right;
                width: 50%;
                height: 120px;
                line-height: 120px;
                font-size: 24px;
                color: #999;
                text-align: right;
            }
        }
        .view_item {
            overflow: hidden;
            margin: 0 auto;
            padding-bottom: 20px;
            width: 630px;
            .view_label {
                float: left;
                width: 125px;
                font-size: 24px;
                color: #999;
            }
            .view_text {
                float: right;
                width: 500px;
                font-size: 24px;
                color: #333;
            }
        }
    }
    .prompt_text {
        padding: 30px 40px;
        width: 630px;
        background-color: #faf8d9;
        font-size: 24px;
        line-height: 1.5em;
        color: #ff5500;
    }
    .button_group {
        margin: 10px 0 0 0;
        width: 710px;
        height: 100px;
        border-top: 1px solid #f2f2f2;
        .button_item {
            width: 353px;
            height: 100px;
            font-size: 32px;
            line-height: 100px;
            text-align: center;
        }
        .later_button {
            float: left;
            color: #333;
        }
        .confirm_button {
            float: right;
            border-left: 1px solid #f2f2f2;
            color: #4bc227;
        }
    }
}
.line-through {
    text-decoration: line-through;
}
</style>
